import { __awaiter, __generator } from "tslib";
import { launchUrl } from './launchUrl';
export var launchWebApp = function (url, appLaunchParams, launchInstrumentationParams) { return __awaiter(void 0, void 0, void 0, function () {
    var action, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(appLaunchParams.disableDefaultLinkBehavior ||
                    !event ||
                    event.defaultPrevented)) return [3 /*break*/, 4];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                action = appLaunchParams.action;
                return [4 /*yield*/, launchUrl(url, { action: action }, launchInstrumentationParams)];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                _a = _b.sent();
                return [2 /*return*/, {
                        success: false,
                        message: 'launchWebApp:launchUrlException',
                    }];
            case 4: return [2 /*return*/, { success: false, message: 'launchWebApp:fallThrough' }];
        }
    });
}); };
//# sourceMappingURL=launchWebApp.js.map